// You can use this instead of creating new objects, which can be useful to
// prevent unnecessary re-renders in React/Redux.
export const emptyArray = Object.freeze([]);
